import { ThemeProvider, type Theme } from "@emotion/react";
import { useCallback, type ReactNode } from "react";

/** Keep Chakra's logical styles and portalled widgets in the same direction as their surface. */
export function LocaleDirectionProvider({ direction, children }: { direction: "ltr" | "rtl"; children: ReactNode }) {
  // The existing Chakra theme is already compiled. Preserve its tokens, color mode and CSS variables.
  const withDirection = useCallback((theme: Theme) => ({ ...theme, direction }), [direction]);
  return <ThemeProvider theme={withDirection}>{children}</ThemeProvider>;
}
